import { getCurrentCloset, putCloset } from "@utils/call-api/closets-call";
import { addSelectedItem, putSelectedItem, removeSelectedItem, validateCloset } from "@utils/call-api/customize-call";
import Cookies from "js-cookie";

export const TYPES = {
  SET_CUSTOMIZABLE_CLOSET: "SET_CUSTOMIZABLE_CLOSET",
  PUT_CUSTOMIZABLE_CLOSET: "PUT_CUSTOMIZABLE_CLOSET",
  PUT_SELECTED_ITEM: "PUT_SELECTED_ITEM",
  UPDATE_ANTICIPATED_ADD_ON_COUNT: "UPDATE_ANTICIPATED_ADD_ON_COUNT",
  UPDATE_ANTICIPATED_ADD_ON_ERROR: "UPDATE_ANTICIPATED_ADD_ON_ERROR",
};

function setAddOnCountOnCookies(count) {
  const now = Date.now();
  const addOnCounter = { count, lastUpdated: now };

  Cookies.set("add_on_count", addOnCounter, { expires: 1 });
}

async function getAddOnCountFromCookies() {
  const addOnCounter = Cookies.get("add_on_count");
  const addOnCounterParsed = addOnCounter ? JSON.parse(addOnCounter) : {};
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  const lastUpdated = new Date(addOnCounterParsed?.lastUpdated);

  if (!addOnCounterParsed?.lastUpdated || lastUpdated < yesterday) return { count: 0, valid: false };

  return { count: addOnCounterParsed.count, valid: true };
}

function setCloset(customizableCloset) {
  return {
    type: TYPES.SET_CUSTOMIZABLE_CLOSET,
    customizableCloset,
  };
}

function updateCloset(customizableCloset) {
  return {
    type: TYPES.PUT_CUSTOMIZABLE_CLOSET,
    customizableCloset,
  };
}

function putItem(selectedItem) {
  return {
    type: TYPES.PUT_SELECTED_ITEM,
    selectedItem,
  };
}

function updateAnticipatedAddOnCount(anticipatedAddOnCount) {
  return {
    type: TYPES.UPDATE_ANTICIPATED_ADD_ON_COUNT,
    anticipatedAddOnCount,
  };
}

function updateAnticipatedAddOnError(anticipatedAddOnError) {
  return {
    type: TYPES.UPDATE_ANTICIPATED_ADD_ON_ERROR,
    anticipatedAddOnError,
  };
}

async function initAnticipatedAddOnsCounter(dispatch, closet) {
  if (closet?.state !== "ready_to_change") return;

  const addOnCountInStorage = await getAddOnCountFromCookies();
  const { add_on_credit: addOnCredit, add_ons_count: addOnCountInCloset } = closet.add_ons_summary;

  let anticipatedAddOnCount;
  if (!addOnCountInStorage.valid && addOnCredit > 0) {
    anticipatedAddOnCount = Math.max(1, addOnCountInCloset);
  } else {
    anticipatedAddOnCount = Math.max(addOnCountInStorage.count, addOnCountInCloset);
  }

  dispatch(updateAnticipatedAddOnCount(anticipatedAddOnCount));
}

export function increaseAnticipatedAddOnCount() {
  return async (dispatch, getState) => {
    const { customizableCloset } = getState();
    const anticipatedAddOnCount = customizableCloset.anticipatedAddOnCount + 1;

    setAddOnCountOnCookies(anticipatedAddOnCount);
    dispatch(updateAnticipatedAddOnCount(anticipatedAddOnCount));
  };
}

export function decreaseAnticipatedAddOnCount() {
  return async (dispatch, getState) => {
    const { customizableCloset } = getState();
    const anticipatedAddOnCount = customizableCloset.anticipatedAddOnCount - 1;

    setAddOnCountOnCookies(anticipatedAddOnCount);
    dispatch(updateAnticipatedAddOnCount(anticipatedAddOnCount));
  };
}

export function changeAnticipatedAddOnError(newError) {
  return async (dispatch) => {
    dispatch(updateAnticipatedAddOnError(newError));
  };
}

export async function setCustomizableCloset(dispatch) {
  try {
    const closet = await getCurrentCloset();
    dispatch(setCloset(closet));
    initAnticipatedAddOnsCounter(dispatch, closet);
    return closet;
  } catch (err) {
    throw err.response;
  }
}

export function reloadCustomizableCloset() {
  return async (dispatch) => {
    try {
      const closet = await getCurrentCloset();
      dispatch(setCloset(closet));
      return closet;
    } catch (err) {
      throw err.response;
    }
  };
}

export function addSelectedItemToCloset(selectedVariant) {
  return async (dispatch, getState) => {
    const closetId = getState().customizableCloset.currentCloset.id;

    const closet = await addSelectedItem(closetId, selectedVariant);
    dispatch(updateCloset(closet));
    initAnticipatedAddOnsCounter(dispatch, closet);
    return closet;
  };
}

export function removeSelectedItemFromCloset(selectedItemId) {
  return async (dispatch, getState) => {
    const closetId = getState().customizableCloset.currentCloset.id;

    const closet = await removeSelectedItem(closetId, selectedItemId);
    dispatch(updateCloset(closet));
    dispatch(updateAnticipatedAddOnError(""));
    return closet;
  };
}

export function putSelectedItemInCloset(selectedItemId, selectedVariant) {
  return async (dispatch, getState) => {
    const closetId = getState().customizableCloset.currentCloset.id;

    const selectedItem = await putSelectedItem(closetId, selectedItemId, selectedVariant);
    dispatch(putItem(selectedItem));
    return selectedItem;
  };
}

export function validateCurrentCloset() {
  return async (dispatch, getState) => {
    const closetId = getState().customizableCloset.currentCloset.id;

    const closet = await validateCloset(closetId);
    dispatch(updateCloset(closet));
    return closet;
  };
}

export function currentClosetBackToRTC() {
  return async (dispatch, getState) => {
    const closetId = getState().customizableCloset.currentCloset.id;

    const closet = await putCloset(closetId, { back_to_change: true });
    dispatch(updateCloset(closet));
    initAnticipatedAddOnsCounter(dispatch, closet);
    return closet;
  };
}
